import {store} from "./app/store";
import {setCurrentPassage} from "./app/projectSlice";

export let passages = {};
export const links = {};

export const registerPassages = (newPassages = {}, moduleName = "") => {
    const _newPassages = {};
    links[moduleName] = {};
    for (const [pasName, pas] of Object.entries(newPassages)) {
        _newPassages[moduleName+'.'+pasName] = pas;
        links[moduleName][pasName] = moduleName+'.'+pasName;
    }
    passages = {...passages, ..._newPassages};
};

export const jumpTo = (passageName = "") => {
    store.dispatch(setCurrentPassage(passageName));
};